import React from "react";
import { ProductWrapper, NoFavoritesText } from './styles';
import { HeaderTextButton } from '../../../../common/Header/styles';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const NoProduct = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ProductWrapper>
      <NoFavoritesText>
        {t("noProducts")}
      </NoFavoritesText>
        <HeaderTextButton cream onClick={() => navigate('/shop')} style={{ boxShadow: '0 3px 3px -2px rgba(0,0,0,.2), 0 3px 4px 0 rgba(0,0,0,.14), 0 1px 8px 0 rgba(0,0,0,.12)' }}>
          {t('shopNow')}
        </HeaderTextButton>
    </ProductWrapper>
  );
};

export default NoProduct;
